module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fs",
    attrs: {
      "id": "page026"
    }
  }, [_c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_1"
    }
  }, [_vm._v("PROVENÇAL PESTO")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_2"
    }
  }, [_vm._v("TIME REQUIRED:")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_3"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("he original recipe")]), _vm._v(" for pesto, "), _c('span', {
    staticClass: "page026_3a"
  }, [_vm._v("pistou")]), _vm._v(" in French, consists of only")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_4"
    }
  }, [_vm._v("10 minutes")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_5"
    }
  }, [_vm._v("olive oil, fresh basil and garlic.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_6"
    }
  }, [_vm._v("100 ml extra-virgin")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_7"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_7a"
    }
  }, [_c('span', {
    staticClass: "page026_7a"
  }, [_vm._v(" Crush the solid ingredients into a thick paste in a mortar.")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_8"
    }
  }, [_vm._v("2.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_8a"
    }
  }, [_c('span', {
    staticClass: "page026_8a"
  }, [_vm._v(" Mix in the oil in a thin stream to make a thick sauce.")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_9"
    }
  }, [_vm._v("olive oil")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_10"
    }
  }, [_vm._v("3.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_10a"
    }
  }, [_c('span', {
    staticClass: "page026_10a"
  }, [_vm._v(" Season with salt.")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_11"
    }
  }, [_vm._v("40 g pine nuts")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_12"
    }
  }, [_vm._v("1 bunch basil")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_13"
    }
  }, [_vm._v("5 cloves garlic")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_14"
    }
  }, [_vm._v("1 tsp yeast flakes")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_15"
    }
  }, [_vm._v("Salt, pepper")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_16"
    }
  }, [_vm._v("VINAIGRETTE")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_17"
    }
  }, [_vm._v("2 tbsp red wine vinegar")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_18"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("he word ")]), _c('span', {
    staticClass: "page026_18a"
  }, [_vm._v("VINAIGRE")]), _vm._v(", the French word for vinegar, literally means")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_19"
    }
  }, [_vm._v("‘sour wine’. The better the quality of the wine, the better the quality")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_20"
    }
  }, [_vm._v("7 tbsp olive oil")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_21"
    }
  }, [_vm._v("of the vinegar.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_22"
    }
  }, [_vm._v("1 tsp Dijon mustard")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_23"
    }
  }, [_vm._v("1 pinch sugar")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_24"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_24a"
    }
  }, [_c('span', {
    staticClass: "page026_24a"
  }, [_vm._v(" Mix the vinegar with the mustard, sugar, salt and pepper.")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_25"
    }
  }, [_vm._v("1 tsp salt")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_26"
    }
  }, [_vm._v("2.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_26a"
    }
  }, [_c('span', {
    staticClass: "page026_26a"
  }, [_vm._v("Add the oil in a thin stream while whisking with a hand mixer")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_27"
    }
  }, [_vm._v("Pepper")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_28"
    }
  }, [_vm._v("to give the dressing a creamy consistency.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_29"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "pagen"
  }, [_vm._v("asics")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page026_0"
    }
  }, [_vm._v("26")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-606bffb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_026.vue
// module id = 132
// module chunks = 0